module.exports = __webpack_public_path__ + "img/file-icon.f09d0ccc.svg";